module.exports = __webpack_public_path__ + "f6e151f6afde4b0d09261f87b65d411c.png";